module.exports = __webpack_public_path__ + "img/registersigfoxdevice.c367dd00.png";